import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { Widget } from '../../../Widget'
import { useRequestProfileContext } from '../../RequestProfile.hooks'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import { useRequestProfileWidgetProvidersData } from './RequestProfileWidgetProviders.hooks'
import {
  getRequestProfileWidgetProvidersPermissions,
  getRequestProfileWidgetProvidersVisibility,
} from './RequestProfileWidgetProviders.utils'
import { RequestProfileWidgetProvidersContent } from './RequestProfileWidgetProvidersContent'

import * as styles from './RequestProfileWidgetProviders.module.css'

function RequestProfileWidgetProviders({ isSkeleton }) {
  const { t } = useTranslation()

  const {
    handleCloseModal,
    modal,
    outboundUuid,
    requestContractors,
    requestData,
    requestProvidersPermissions,
  } = useRequestProfileContext()

  const requestPermissions = outboundUuid
    ? requestProvidersPermissions
    : requestData?.permissions

  const { formInitialValues, handleSubmit, recommendedProviders } =
    useRequestProfileWidgetProvidersData({
      requestId: requestData?.id,
      requestPermissions,
    })

  const { canEditContractors } =
    getRequestProfileWidgetProvidersPermissions(requestPermissions)

  const { hasContent } = getRequestProfileWidgetProvidersVisibility({
    recommendedProviders,
    requestPermissions,
  })

  const actionsProps = {
    ...(hasContent ? EMPTY_OBJECT : { ExpandButton: null }),
    ...(canEditContractors ? EMPTY_OBJECT : { EditButton: null }),
  }

  return (
    <Widget
      contentContainerProps={{
        className: styles.content,
      }}
      headerProps={{
        contentProps: {
          actionsProps,
        },
      }}
      isSkeleton={isSkeleton}
      qaName={RequestProfileWidgetKey.PROVIDERS}
      title={t('RequestProfile.ProvidersWidgetTitleKey')}
    >
      <RequestProfileWidgetProvidersContent
        initialValues={formInitialValues}
        modal={modal}
        providers={requestContractors}
        recommendedProviders={recommendedProviders}
        requestId={requestData?.id}
        requestPermissions={requestPermissions}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />
    </Widget>
  )
}

export default RequestProfileWidgetProviders
